jQuery.fn.ornamentSection = function() {
  let self = this

  if(self.is( ":first-child" )){
    self.closest('.page-section').addClass('page-section--ornament-as-first');
  }

  if(self.is( ":last-child" )){
    self.closest('.page-section').addClass('page-section--ornament-as-last');
  }

  return function() {
    return self
  }()
};
